import { CommonService } from '@/services/common.service'

export default {
  data() {
    return {
      systemConfig: {
        multiFuncAppendixType: [],
        tableContactInfos: [],
        configFeePg: [],
      },
    }
  },
  mounted() {},
  computed: {},
  methods: {
    getConfigSystem() {
      return CommonService.getConfigSystem()
        .then(data => {
          if (data.success) {
            const config = data.data
            this.systemConfig = {
              multiFuncAppendixType: this.map(config.multiFuncAppendixType),
              tableContactInfos: this.map(config.tableContactInfos),
              configFeePg: config.configFeePg,
            }
          }
        })
        .catch(error => console.log(error))
    },
    map(items, id = 'code', text = 'name') {
      return items.map(e => ({ id: e[id], text: e[text] }))
    },
  },
}
